<!-- <div class="col-md-6 col-lg-6">
  <ng-container #container1></ng-container>
</div>
<div class="col-md-6 col-lg-6">
  <ng-container #container2></ng-container>
</div> -->

<!--end of container-->

<div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutAlign="space-around center" fxLayoutGap="20px">
  <div fxFlex="calc(50% -20px)">
    <ng-container #container1></ng-container>
  </div>
  <div fxFlex="calc(50% -20px)">
    <ng-container #container2></ng-container>
  </div>
</div>
